import * as EmailValidator from 'email-validator';

export const digitRegex = /\d/;

export const validateEmail = (email: string) => {
  return EmailValidator.validate(email);
};

export const numOnly = event => {
  const key = event.keyCode || event.which;
  if (
    (key >= 48 && key <= 57) ||
    (key >= 96 && key <= 105) ||
    [8, 9, 13, 35, 36, 37, 39].includes(key) ||
    (event.ctrlKey === true && [65, 67, 86, 88, 90].includes(key))
  ) {
  } else {
    event.preventDefault();
  }
};

export const noSpecial = evt => {
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (!(charCode > 31 && (charCode < 48 || charCode > 57)) || charCode === 46) {
  } else evt.preventDefault();
};

export const numberValidation = (evt, amount) => {
  if (+evt.target.value <= +amount) {
  } else evt.preventDefault();
};
